import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FeedbackModal } from './FeedbackModal';

export function FeedbackButton() {
  const { t } = useTranslation('feedback');
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={t('button')}
        title={t('button')}
        className="fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full bg-[color:var(--color-primary)] px-4 py-3 text-sm font-medium text-white shadow-lg hover:bg-[color:var(--color-primary-hover)] focus:outline-none focus:ring-2 focus:ring-[color:var(--color-primary)] focus:ring-offset-2 transition-all"
      >
        <span aria-hidden className="text-base">
          💬
        </span>
        <span className="hidden sm:inline">{t('button')}</span>
      </button>

      {open && <FeedbackModal onClose={() => setOpen(false)} />}
    </>
  );
}
